import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function PlannedHandoffExceptionDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const startOnCtrl = control.get('startOn');
    const endOnCtrl = control.get('endOn');
    const showWarningOnCtrl = control.get('showWarningOn');

    const startOn = moment(startOnCtrl?.value);
    const endOn = moment(endOnCtrl?.value);
    const showWarningOn = moment(showWarningOnCtrl?.value);

    // Clear previous custom errors so they don't persist
    endOnCtrl?.setErrors(null);
    showWarningOnCtrl?.setErrors(null);

    if (endOn.isBefore(startOn)) {
      endOnCtrl?.setErrors({ endBeforeStart: true });
      errors['endBeforeStart'] = true;
    }

    if (showWarningOn.isAfter(startOn)) {
      showWarningOnCtrl?.setErrors({ startBeforeWarning: true });
      errors['startBeforeWarning'] = true;
    }

    return Object.keys(errors).length === 0 ? null : errors;
  };
}
